import { useMemo } from "react";

import { useAppSelector } from "~/store/hooks";
import { CropScope, customerScope } from "~/utils/crops/use-crop-list";

import { getImportCustomerGuids } from "./selectors";

/** The matched customers, else Catalog. Selects a joined key so the scope stays stable. */
export const useImportCropScope = (): CropScope => {
    const customersKey = useAppSelector((state) => getImportCustomerGuids(state).join("|"));
    return useMemo(
        () => customerScope(customersKey ? customersKey.split("|") : []),
        [customersKey]
    );
};
